import { FC, useRef } from 'react';
import { Box, Flex, Image, Text, Tooltip, useTheme } from '@chakra-ui/react';
import { rgba } from 'polished';
import { useTranslation } from 'react-i18next';
import useBreakpoint from 'hooks/useBreakpoint';
import useOverflown from 'hooks/useOverflown';

interface Props {
  name?: string;
  profileType: ProfileType;
  pictureUrl?: string;
  showTooltip?: boolean;
}

const ProfileCard: FC<Props> = ({ name, profileType, pictureUrl, showTooltip }) => {
  const { colors } = useTheme();
  const { isTablet } = useBreakpoint();
  const { t } = useTranslation('common');
  const ref = useRef<HTMLParagraphElement>(null);

  const isOverflown = useOverflown(ref, 'horizontal');

  return (
    <Flex alignItems="center">
      <Image src={pictureUrl} boxSize="32px" bgColor={colors.secondary[300]} borderRadius="4px" />
      <Box textAlign="start" ml="10px">
        <Text fontSize={isTablet ? 'lgMin' : 'xs'} fontWeight={400} color={isTablet ? 'colors.secondary.600' : rgba(colors.white, 0.6)}>
          {profileType === 'Company' ? t('profileMenu.team') : isTablet ? t('profileMenu.personal') : t('profileMenu.personalProfile')}
        </Text>
        {name && (
          <Tooltip label={name} placement="bottom-end" isOpen={showTooltip && isOverflown}>
            <Text ref={ref} fontWeight={500} color={rgba(colors.white, 0.9)} maxW="150px" overflow="hidden" textOverflow="ellipsis">
              {name}
            </Text>
          </Tooltip>
        )}
      </Box>
    </Flex>
  );
};

export default ProfileCard;
